'use client';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import { apiUrl } from '../apiConfig';

const BRAND = '#facc15';
const BRAND_RGB = '250,204,21';
const BG_BASE = '#020617';

const IMG = {
  hero:     'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1800&q=80&fit=crop',
  problema: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=1400&q=80&fit=crop',
  comousar: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1800&q=80&fit=crop',
  cta:      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1800&q=80&fit=crop&crop=top',
  depo1:    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80&fit=crop&crop=face',
  depo2:    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80&fit=crop&crop=face',
  depo3:    'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=120&q=80&fit=crop&crop=face',
  ben1:     'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80&fit=crop',
  ben2:     'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80&fit=crop',
  ben3:     'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&fit=crop',
  ben4:     'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80&fit=crop',
  ben5:     'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=800&q=80&fit=crop',
  ben6:     'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80&fit=crop',
};

const fadeUp  = { hidden:{ opacity:0, y:30 }, show:{ opacity:1, y:0, transition:{ duration:0.65, ease:[0.22,1,0.36,1] } } };
const stagger = { show:{ transition:{ staggerChildren:0.1 } } };

const WaIcon = ({ size=20, color='white' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const InstagramIcon = ({ size=20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const Badge = ({ children }) => (
  <span style={{
    display:'inline-block',
    background:`rgba(${BRAND_RGB},0.08)`, border:`1px solid rgba(${BRAND_RGB},0.28)`,
    borderRadius:100, padding:'6px 18px',
    fontSize:'0.72rem', fontWeight:700, color:BRAND,
    letterSpacing:'0.1em', marginBottom:22, textTransform:'uppercase',
  }}>{children}</span>
);

const Separator = () => (
  <div style={{ position:'absolute', top:0, left:0, right:0, height:1,
    background:`linear-gradient(90deg, transparent, rgba(${BRAND_RGB},0.3), transparent)` }}/>
);

const GlowBg = () => (
  <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)',
    width:900, height:600, borderRadius:'50%', pointerEvents:'none',
    background:`radial-gradient(ellipse, rgba(${BRAND_RGB},0.05) 0%, transparent 65%)` }}/>
);

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Contato
  const [contatoNome, setContatoNome] = useState('');
  const [contatoEmail, setContatoEmail] = useState('');
  const [contatoTelefone, setContatoTelefone] = useState('');
  const [contatoMensagem, setContatoMensagem] = useState('');
  const [contatoArquivos, setContatoArquivos] = useState([]);
  const [contatoSending, setContatoSending] = useState(false);
  const [contatoStatus, setContatoStatus] = useState(null); // 'ok' | 'error' | null
  const [contatoStatusMsg, setContatoStatusMsg] = useState('');
  const fileInputContatoRef = useRef(null);

  const handleContatoFiles = (e) => {
    const novos = Array.from(e.target.files || []);
    setContatoArquivos(prev => {
      const combined = [...prev, ...novos].slice(0, 5);
      return combined;
    });
    if (fileInputContatoRef.current) fileInputContatoRef.current.value = '';
  };

  const removeContatoFile = (idx) => {
    setContatoArquivos(prev => prev.filter((_, i) => i !== idx));
  };

  const handleContatoSubmit = async (e) => {
    e.preventDefault();
    if (!contatoNome.trim() || !contatoMensagem.trim()) return;
    setContatoSending(true);
    setContatoStatus(null);
    try {
      const fd = new FormData();
      fd.append('nome', contatoNome.trim());
      fd.append('email', contatoEmail.trim());
      fd.append('telefone', contatoTelefone.trim());
      fd.append('mensagem', contatoMensagem.trim());
      contatoArquivos.forEach(f => fd.append('arquivos', f));
      const res = await fetch(apiUrl('/api/contato'), { method: 'POST', body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro ao enviar');
      setContatoStatus('ok');
      setContatoStatusMsg(data.message || 'Mensagem enviada com sucesso!');
      setContatoNome(''); setContatoEmail(''); setContatoTelefone('');
      setContatoMensagem(''); setContatoArquivos([]);
    } catch (err) {
      setContatoStatus('error');
      setContatoStatusMsg(err.message);
    } finally {
      setContatoSending(false);
    }
  };

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const BENEFICIOS = [
    { img: IMG.ben1, color: BRAND,     title: 'Detecção de Divergências',      desc: 'Nossa perícia identifica cada transação onde a taxa cobrada excede o contratado, apontando o valor exato cobrado a mais.' },
    { img: IMG.ben2, color: '#10b981', title: 'Laudo Técnico de Auditoria',     desc: 'Geramos um laudo técnico pericial com análise das cobranças indevidas e o impacto financeiro total no período.' },
    { img: IMG.ben3, color: '#3b82f6', title: 'Múltiplas Operadoras',           desc: 'Cobertura completa: Stone, Cielo, Rede, GetNet, Sipag, PagSeguro, Mercado Pago e outras — mesma precisão em todas.' },
    { img: IMG.ben4, color: '#8b5cf6', title: 'Taxas Personalizadas',           desc: 'Configure as taxas contratuais de cada modalidade — PIX, débito, crédito à vista e parcelado — para comparação precisa.' },
    { img: IMG.ben5, color: '#f59e0b', title: 'Análise em Minutos',             desc: 'Inteligência artificial lê o extrato, cruza com as taxas contratadas e entrega o relatório de auditoria em menos de 2 minutos.' },
    { img: IMG.ben6, color: '#ef4444', title: 'Plataforma Segura',              desc: 'Acesso restrito, autenticação por credencial, dados protegidos e infraestrutura auditada pela Brasil Soluções Empresariais.' },
  ];

  const PASSOS = [
    { n:'01', icon:'📁', title:'Envie o extrato',          desc:'Selecione a operadora e faça upload do extrato CSV exportado do seu sistema de maquininha.' },
    { n:'02', icon:'⚙️', title:'Configure o contrato',     desc:'Informe as taxas contratadas para cada modalidade — PIX, débito, crédito e parcelado.' },
    { n:'03', icon:'🔍', title:'Perícia automatizada',      desc:'Nossa IA audita cada transação, calcula a taxa efetiva cobrada e identifica todas as divergências.' },
    { n:'04', icon:'📊', title:'Receba o laudo',            desc:'Relatório técnico com tabela de divergências, impacto financeiro acumulado e conclusão pericial.' },
  ];

  const cardStyle = {
    background:'rgba(255,255,255,0.03)', backdropFilter:'blur(20px)',
    border:'1px solid rgba(255,255,255,0.07)', borderRadius:20,
    transition:'all 0.3s', overflow:'hidden',
  };

  return (
    <div style={{ background:BG_BASE, color:'#f1f5f9', fontFamily:'Inter, system-ui, sans-serif', overflowX:'hidden' }}>
      <style>{`
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; }
        .btn-brand { background:${BRAND}; color:#020617; border:none; border-radius:14px; padding:16px 32px; font-weight:700; font-size:1rem; box-shadow:0 12px 40px rgba(${BRAND_RGB},0.28); transition:all 0.2s; }
        .btn-brand:hover { transform:translateY(-2px); box-shadow:0 16px 48px rgba(${BRAND_RGB},0.38); background:${BRAND}; color:#020617; }
        .btn-glass { background:rgba(255,255,255,0.07); color:#f1f5f9; border:1px solid rgba(255,255,255,0.15); border-radius:14px; padding:16px 32px; font-weight:600; font-size:1rem; transition:all 0.2s; }
        .btn-glass:hover { background:rgba(255,255,255,0.12); color:#f1f5f9; transform:translateY(-2px); }
        .btn-wa { background:#25D366; color:#fff; border:none; border-radius:14px; padding:16px 32px; font-weight:700; font-size:1rem; box-shadow:0 12px 40px rgba(37,211,102,0.38); transition:all 0.2s; display:inline-flex; align-items:center; gap:10px; }
        .btn-wa:hover { transform:translateY(-2px); box-shadow:0 16px 48px rgba(37,211,102,0.5); color:#fff; }
        .card-hover:hover { border-color:rgba(${BRAND_RGB},0.35) !important; transform:translateY(-5px) !important; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media(max-width:768px){ .hero-title{ font-size:2.4rem !important; } .hero-sub{ font-size:1rem !important; } }
      `}</style>

      {/* NAVBAR */}
      <nav style={{
        position:'fixed', top:0, left:0, right:0, zIndex:999,
        padding:'0 24px',
        background: scrolled ? 'rgba(2,6,23,0.97)' : 'transparent',
        backdropFilter: scrolled ? 'blur(24px)' : 'none',
        borderBottom: scrolled ? `1px solid rgba(${BRAND_RGB},0.12)` : 'none',
        transition:'all 0.3s',
      }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'space-between', height:68 }}>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <div style={{ width:36, height:36, borderRadius:10, background:`rgba(${BRAND_RGB},0.15)`, border:`1px solid rgba(${BRAND_RGB},0.3)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem' }}>📊</div>
            <span style={{ fontWeight:800, fontSize:'1.15rem', color:BRAND }}>Delator</span>
            <span style={{ fontSize:'0.7rem', color:'rgba(241,245,249,0.4)', fontWeight:500, marginLeft:2 }}>Auditoria Financeira</span>
          </div>
          <div className="d-none d-lg-flex" style={{ gap:32, alignItems:'center' }}>
            {[['#beneficios','Benefícios'],['#como-usar','Como Usar'],['#funcionalidades','Funcionalidades'],['#depoimentos','Depoimentos'],['#contato','Contato']].map(([h,l])=>(
              <a key={h} href={h} style={{ color:'rgba(241,245,249,0.7)', textDecoration:'none', fontSize:'0.9rem', fontWeight:500, transition:'color 0.2s' }}
                onMouseEnter={e=>e.target.style.color='#f1f5f9'} onMouseLeave={e=>e.target.style.color='rgba(241,245,249,0.7)'}>{l}</a>
            ))}
          </div>
          <div className="d-none d-lg-flex" style={{ gap:12 }}>
            <Link to="/login" className="btn btn-glass" style={{ padding:'9px 22px', fontSize:'0.88rem' }}>Entrar</Link>
            <Link to="/cadastro" className="btn btn-brand" style={{ padding:'9px 22px', fontSize:'0.88rem' }}>Criar conta</Link>
          </div>
          <button className="d-lg-none" onClick={()=>setMenuOpen(!menuOpen)}
            style={{ background:'transparent', border:`1px solid rgba(${BRAND_RGB},0.3)`, borderRadius:10, padding:'8px 12px', color:BRAND }}>
            ☰
          </button>
        </div>
        {menuOpen && (
          <div style={{ background:'rgba(2,6,23,0.98)', borderTop:`1px solid rgba(${BRAND_RGB},0.1)`, padding:'16px 24px', display:'flex', flexDirection:'column', gap:12 }}>
            {[['#beneficios','Benefícios'],['#como-usar','Como Usar'],['#funcionalidades','Funcionalidades'],['#depoimentos','Depoimentos'],['#contato','Contato']].map(([h,l])=>(
              <a key={h} href={h} onClick={()=>setMenuOpen(false)} style={{ color:'rgba(241,245,249,0.8)', textDecoration:'none', padding:'8px 0', fontSize:'1rem' }}>{l}</a>
            ))}
            <Link to="/cadastro" className="btn btn-brand" style={{ marginTop:8, textAlign:'center' }}>Criar conta grátis</Link>
            <Link to="/login" className="btn btn-glass" style={{ marginTop:8, textAlign:'center' }}>Já tenho conta</Link>
          </div>
        )}
      </nav>

      {/* HERO */}
      <section style={{ position:'relative', minHeight:'100vh', display:'flex', alignItems:'center', overflow:'hidden' }}>
        <img src={IMG.hero} alt="" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }}/>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, rgba(2,6,23,0.93) 0%, rgba(2,6,23,0.76) 50%, rgba(2,6,23,0.89) 100%)' }}/>
        <GlowBg/>
        <div style={{ position:'relative', zIndex:2, maxWidth:1200, margin:'0 auto', padding:'100px 24px 80px', width:'100%' }}>
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <motion.div initial="hidden" animate="show" variants={stagger}>
                <motion.div variants={fadeUp}>
                  <Badge>Consultoria e Perícia Bancária</Badge>
                </motion.div>
                <motion.h1 variants={fadeUp} className="hero-title" style={{ fontSize:'clamp(2.4rem,5vw,3.6rem)', fontWeight:900, lineHeight:1.1, marginBottom:20 }}>
                  Auditoria pericial nas taxas da <span style={{ color:BRAND }}>sua maquininha</span>
                </motion.h1>
                <motion.p variants={fadeUp} className="hero-sub" style={{ fontSize:'1.1rem', color:'rgba(241,245,249,0.7)', lineHeight:1.7, marginBottom:36, maxWidth:480 }}>
                  Consultoria e perícia bancária especializada. Enviamos o extrato da sua operadora, cruzamos com as taxas contratadas e entregamos um laudo técnico completo de todas as cobranças indevidas.
                </motion.p>
                <motion.div variants={fadeUp} style={{ display:'flex', flexWrap:'wrap', gap:14 }}>
                  <Link to="/cadastro" className="btn btn-brand">Criar conta grátis</Link>
                  <a href="#como-usar" className="btn btn-glass">Ver como funciona</a>
                </motion.div>
                <motion.div variants={fadeUp} style={{ display:'flex', gap:32, marginTop:40, flexWrap:'wrap' }}>
                  {[['Stone','💳'],['Cielo','💳'],['Rede','💳'],['Sipag','💳'],['Amex','💳']].map(([n,i])=>(
                    <div key={n} style={{ textAlign:'center' }}>
                      <div style={{ fontSize:'0.7rem', color:'rgba(241,245,249,0.4)', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.08em' }}>{n}</div>
                    </div>
                  ))}
                </motion.div>
              </motion.div>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <motion.div initial={{ opacity:0, x:40 }} animate={{ opacity:1, x:0 }} transition={{ duration:0.8, delay:0.3, ease:[0.22,1,0.36,1] }}>
                <div style={{ position:'relative', maxWidth:440, marginLeft:'auto' }}>
                  {/* App mockup */}
                  <div style={{
                    background:'rgba(5,14,35,0.88)', backdropFilter:'blur(28px)',
                    border:'1px solid rgba(255,255,255,0.1)', borderRadius:24,
                    padding:26, boxShadow:'0 48px 96px rgba(0,0,0,0.65)',
                  }}>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ width:32, height:32, borderRadius:8, background:`rgba(${BRAND_RGB},0.15)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1rem' }}>📊</div>
                        <span style={{ fontWeight:700, fontSize:'0.9rem' }}>Delator</span>
                      </div>
                      <span style={{ fontSize:'0.72rem', color:'#10b981', fontWeight:600, background:'rgba(16,185,129,0.1)', border:'1px solid rgba(16,185,129,0.3)', borderRadius:100, padding:'4px 12px' }}>● Online</span>
                    </div>
                    <div className="row g-2" style={{ marginBottom:20 }}>
                      {[['R$ 2.847','Cobrado a mais',BRAND],['47','Divergências','#ef4444'],['R$ 0,00','Taxa contratual','#10b981']].map(([v,l,c])=>(
                        <div key={l} className="col-4">
                          <div style={{ background:`rgba(${c === BRAND ? BRAND_RGB : c === '#ef4444' ? '239,68,68' : '16,185,129'},0.08)`, border:`1px solid rgba(${c === BRAND ? BRAND_RGB : c === '#ef4444' ? '239,68,68' : '16,185,129'},0.2)`, borderRadius:12, padding:'12px 10px', textAlign:'center' }}>
                            <div style={{ fontSize:'0.9rem', fontWeight:800, color:c }}>{v}</div>
                            <div style={{ fontSize:'0.62rem', color:'rgba(241,245,249,0.45)', marginTop:3 }}>{l}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:12, padding:'14px 16px' }}>
                      <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.4)', marginBottom:10, fontWeight:600, textTransform:'uppercase', letterSpacing:'0.08em' }}>Últimas divergências</div>
                      {[
                        { data:'12/04', mod:'Crédito 3x', taxa:'3.98%', cont:'3.28%', dif:'+R$ 42,10' },
                        { data:'11/04', mod:'Débito', taxa:'1.89%', cont:'1.31%', dif:'+R$ 18,50' },
                        { data:'10/04', mod:'PIX', taxa:'1.10%', cont:'0%', dif:'+R$ 9,90' },
                      ].map((r,i)=>(
                        <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 0', borderBottom: i<2 ? '1px solid rgba(255,255,255,0.04)' : 'none' }}>
                          <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.5)' }}>{r.data}</div>
                          <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.8)' }}>{r.mod}</div>
                          <div style={{ fontSize:'0.7rem', color:'rgba(241,245,249,0.4)' }}>{r.taxa}</div>
                          <div style={{ fontSize:'0.72rem', color:'#ef4444', fontWeight:700 }}>{r.dif}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Floating cards */}
                  <motion.div animate={{ y:[0,-12,0] }} transition={{ repeat:Infinity, duration:3.2, ease:'easeInOut' }}
                    style={{ position:'absolute', top:-22, right:-16, background:'rgba(239,68,68,0.14)', backdropFilter:'blur(18px)', border:'1px solid rgba(239,68,68,0.35)', borderRadius:14, padding:'10px 16px', zIndex:3 }}>
                    <div style={{ fontSize:'0.66rem', color:'#ef4444', fontWeight:700 }}>⚠ Alerta</div>
                    <div style={{ fontSize:'0.76rem', color:'#f1f5f9' }}>Taxa acima do contrato</div>
                  </motion.div>
                  <motion.div animate={{ y:[0,-8,0] }} transition={{ repeat:Infinity, duration:4.1, ease:'easeInOut', delay:1 }}
                    style={{ position:'absolute', bottom:-18, left:-16, background:'rgba(16,185,129,0.14)', backdropFilter:'blur(18px)', border:'1px solid rgba(16,185,129,0.35)', borderRadius:14, padding:'10px 16px', zIndex:3 }}>
                    <div style={{ fontSize:'0.66rem', color:'#10b981', fontWeight:700 }}>✓ Analisado</div>
                    <div style={{ fontSize:'0.76rem', color:'#f1f5f9' }}>1.243 transações</div>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEMA */}
      <section style={{ position:'relative', padding:'100px 0', overflow:'hidden' }}>
        <img src={IMG.problema} alt="" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', filter:'grayscale(60%) brightness(0.35)' }}/>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, rgba(2,6,23,0.88) 0%, rgba(2,6,23,0.78) 50%, rgba(2,6,23,0.92) 100%)' }}/>
        <Separator/>
        <div style={{ position:'relative', zIndex:2, maxWidth:1200, margin:'0 auto', padding:'0 24px' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} style={{ textAlign:'center', marginBottom:60 }}>
            <motion.div variants={fadeUp}><Badge>O Problema</Badge></motion.div>
            <motion.h2 variants={fadeUp} style={{ fontSize:'clamp(1.8rem,4vw,2.8rem)', fontWeight:900, marginBottom:16 }}>
              Sua operadora pode estar cobrando mais do que contratou
            </motion.h2>
            <motion.p variants={fadeUp} style={{ fontSize:'1.05rem', color:'rgba(241,245,249,0.6)', maxWidth:560, margin:'0 auto' }}>
              Erros de arredondamento, aplicação de tabelas incorretas e cobranças não previstas em contrato comprometem o caixa da empresa mês a mês — muitas vezes sem que ninguém perceba.
            </motion.p>
          </motion.div>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} className="row g-4 justify-content-center">
            {[
              { icon:'💸', color:'#ef4444', title:'Cobrança acima do contrato', desc:'Taxa aplicada pela operadora supera o percentual acordado no contrato de credenciamento, gerando prejuízo direto.' },
              { icon:'🔢', color:'#f59e0b', title:'Erros de arredondamento', desc:'Pequenos arredondamentos aplicados sistematicamente acumulam centenas de reais em cobranças indevidas por mês.' },
              { icon:'📑', color:'#8b5cf6', title:'Cobranças não previstas', desc:'Locação de terminal, tarifas de antecipação ou mensalidades debitadas sem qualquer previsão contratual.' },
              { icon:'📉', color:'#3b82f6', title:'Metodologia de cálculo incorreta', desc:'Aplicação equivocada das fórmulas de parcelamento ou antecipação de recebíveis que gera distorção recorrente.' },
            ].map((c,i)=>(
              <div key={i} className="col-sm-6 col-lg-3">
                <motion.div variants={fadeUp}>
                  <div className="card-hover" style={{ ...cardStyle, padding:28, height:'100%', border:'1px solid rgba(255,255,255,0.07)' }}>
                    <div style={{ width:52, height:52, borderRadius:14, background:`rgba(${c.color === '#ef4444' ? '239,68,68' : c.color === '#f59e0b' ? '245,158,11' : c.color === '#8b5cf6' ? '139,92,246' : '59,130,246'},0.12)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.5rem', marginBottom:18 }}>{c.icon}</div>
                    <h4 style={{ fontWeight:700, fontSize:'1rem', marginBottom:10 }}>{c.title}</h4>
                    <p style={{ fontSize:'0.875rem', color:'rgba(241,245,249,0.52)', lineHeight:1.65, margin:0 }}>{c.desc}</p>
                  </div>
                </motion.div>
              </div>
            ))}
          </motion.div>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={fadeUp} style={{ textAlign:'center', marginTop:60 }}>
            <div style={{ display:'inline-block', background:`rgba(${BRAND_RGB},0.06)`, border:`1px solid rgba(${BRAND_RGB},0.2)`, borderRadius:20, padding:'28px 48px' }}>
              <div style={{ fontSize:'clamp(2.5rem,6vw,4rem)', fontWeight:900, color:BRAND, lineHeight:1 }}>73%</div>
              <div style={{ fontSize:'1rem', color:'rgba(241,245,249,0.6)', marginTop:8 }}>dos estabelecimentos auditados apresentam cobranças em desacordo com o contrato de credenciamento</div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* BENEFÍCIOS */}
      <section id="beneficios" style={{ position:'relative', padding:'100px 0' }}>
        <Separator/>
        <GlowBg/>
        <div style={{ position:'relative', zIndex:2, maxWidth:1200, margin:'0 auto', padding:'0 24px' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} style={{ textAlign:'center', marginBottom:60 }}>
            <motion.div variants={fadeUp}><Badge>Benefícios</Badge></motion.div>
            <motion.h2 variants={fadeUp} style={{ fontSize:'clamp(1.8rem,4vw,2.8rem)', fontWeight:900 }}>
              Tudo que você precisa para uma perícia completa
            </motion.h2>
          </motion.div>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} className="row g-4">
            {BENEFICIOS.map((b,i)=>(
              <div key={i} className="col-md-6 col-lg-4">
                <motion.div variants={fadeUp} style={{ height:'100%' }}>
                  <div className="card-hover" style={{ ...cardStyle, border:'1px solid rgba(255,255,255,0.07)', height:'100%', display:'flex', flexDirection:'column' }}
                    onMouseEnter={e=>{ e.currentTarget.style.borderColor=`${b.color}45`; e.currentTarget.style.transform='translateY(-6px)'; e.currentTarget.style.boxShadow=`0 20px 60px ${b.color}12`; }}
                    onMouseLeave={e=>{ e.currentTarget.style.borderColor='rgba(255,255,255,0.07)'; e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none'; }}>
                    <img src={b.img} alt={b.title} style={{ width:'100%', height:180, display:'block', objectFit:'cover', borderBottom:'1px solid rgba(255,255,255,0.07)' }}/>
                    <div style={{ padding:'22px 24px 26px', flex:1 }}>
                      <h3 style={{ fontSize:'1rem', fontWeight:700, marginBottom:8 }}>{b.title}</h3>
                      <p style={{ fontSize:'0.875rem', color:'rgba(241,245,249,0.52)', lineHeight:1.65, margin:0 }}>{b.desc}</p>
                    </div>
                  </div>
                </motion.div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* COMO USAR */}
      <section id="como-usar" style={{ position:'relative', padding:'100px 0', overflow:'hidden' }}>
        <img src={IMG.comousar} alt="" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }}/>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, rgba(2,6,23,0.93) 0%, rgba(7,17,31,0.88) 60%, rgba(2,6,23,0.95) 100%)' }}/>
        <Separator/>
        <div style={{ position:'relative', zIndex:2, maxWidth:1200, margin:'0 auto', padding:'0 24px' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} style={{ textAlign:'center', marginBottom:60 }}>
            <motion.div variants={fadeUp}><Badge>Como Usar</Badge></motion.div>
            <motion.h2 variants={fadeUp} style={{ fontSize:'clamp(1.8rem,4vw,2.8rem)', fontWeight:900 }}>
              Do extrato ao laudo pericial em minutos
            </motion.h2>
          </motion.div>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} className="row g-4">
            {PASSOS.map((p,i)=>(
              <div key={i} className="col-sm-6 col-lg-3">
                <motion.div variants={fadeUp}>
                  <div style={{ ...cardStyle, border:'1px solid rgba(255,255,255,0.07)', padding:28, height:'100%', position:'relative' }}>
                    <div style={{ position:'absolute', top:16, right:20, fontSize:'0.7rem', fontWeight:800, color:`rgba(${BRAND_RGB},0.25)`, letterSpacing:'0.05em' }}>{p.n}</div>
                    <div style={{ fontSize:'2rem', marginBottom:16 }}>{p.icon}</div>
                    <h4 style={{ fontWeight:700, fontSize:'1rem', marginBottom:10, color:BRAND }}>{p.title}</h4>
                    <p style={{ fontSize:'0.875rem', color:'rgba(241,245,249,0.52)', lineHeight:1.65, margin:0 }}>{p.desc}</p>
                  </div>
                </motion.div>
              </div>
            ))}
          </motion.div>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={fadeUp} style={{ textAlign:'center', marginTop:48, display:'flex', justifyContent:'center', gap:16, flexWrap:'wrap' }}>
            <Link to="/cadastro" className="btn btn-brand">Criar conta grátis</Link>
            <Link to="/login" className="btn btn-glass">Já tenho conta</Link>
          </motion.div>
        </div>
      </section>

      {/* FUNCIONALIDADES */}
      <section id="funcionalidades" style={{ position:'relative', padding:'100px 0' }}>
        <Separator/>
        <div style={{ maxWidth:1200, margin:'0 auto', padding:'0 24px' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} style={{ textAlign:'center', marginBottom:70 }}>
            <motion.div variants={fadeUp}><Badge>Funcionalidades</Badge></motion.div>
            <motion.h2 variants={fadeUp} style={{ fontSize:'clamp(1.8rem,4vw,2.8rem)', fontWeight:900 }}>
              Perícia técnica automatizada e completa
            </motion.h2>
          </motion.div>

          {[
            { title:'Laudo detalhado por transação', desc:'Para cada cobrança indevida identificada, o laudo apresenta: data, modalidade, valor bruto, taxa contratada, taxa efetivamente cobrada, diferença em pontos percentuais e o valor indevido em reais — pronto para ser apresentado à operadora.', pills:['Laudo por transação','Diferença em R$','Taxa efetiva vs contratada'], mockup:[
              { label:'Transação #04891', sub:'Crédito 3x · 12/04/2025', val:'+R$ 42,10', color:'#ef4444' },
              { label:'Transação #04902', sub:'Débito · 11/04/2025', val:'+R$ 18,50', color:'#ef4444' },
              { label:'Transação #04915', sub:'PIX · 10/04/2025', val:'+R$ 9,90', color:'#f59e0b' },
            ]},
            { title:'Sumário executivo com impacto financeiro', desc:'Além das ocorrências individuais, geramos um sumário consolidado com o total de cobranças divergentes, impacto financeiro acumulado no período, modalidades mais afetadas e conclusão técnica da auditoria.', pills:['Impacto total em R$','Modalidades auditadas','Conclusão técnica'], mockup:[
              { label:'Total cobrado indevidamente', sub:'Período 01/04 a 30/04', val:'R$ 2.847,30', color:BRAND },
              { label:'Transações auditadas', sub:'47 divergências em 1.243', val:'3,78%', color:'#f59e0b' },
              { label:'Principal irregularidade', sub:'Taxa acima do contratado', val:'Crédito 3x', color:'#8b5cf6' },
            ]},
            { title:'Cobertura completa de cobranças', desc:'A perícia cobre taxas de transação, locação de terminal, antecipação de recebíveis e vouchers de benefício — todas as modalidades verificadas contra o que está no seu contrato de credenciamento.', pills:['Taxas de transação','Locação e antecipação','Vouchers e benefícios'], mockup:[
              { label:'Locação de terminal', sub:'Cobrança vs contrato', val:'Verificado', color:'#10b981' },
              { label:'Antecipação de recebíveis', sub:'Taxa ARV auditada', val:'Verificado', color:'#3b82f6' },
              { label:'Voucher / Benefício', sub:'Alelo, Sodexo, VR, Ticket', val:'Verificado', color:BRAND },
            ]},
          ].map((f,i)=>(
            <motion.div key={i} initial="hidden" whileInView="show" viewport={{ once:true, margin:'-80px' }} variants={stagger}
              className="row g-5 align-items-center" style={{ marginBottom:80, paddingBottom:80, borderBottom:i<2?'1px solid rgba(255,255,255,0.05)':'none' }}>
              <div className={`col-lg-5 ${i%2===1?'order-lg-2':''}`}>
                <motion.div variants={fadeUp}>
                  <h3 style={{ fontSize:'clamp(1.4rem,3vw,1.9rem)', fontWeight:800, marginBottom:16 }}>{f.title}</h3>
                  <p style={{ fontSize:'1rem', color:'rgba(241,245,249,0.62)', lineHeight:1.75, marginBottom:24 }}>{f.desc}</p>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:10 }}>
                    {f.pills.map(p=>(
                      <span key={p} style={{ background:`rgba(${BRAND_RGB},0.08)`, border:`1px solid rgba(${BRAND_RGB},0.2)`, borderRadius:100, padding:'6px 16px', fontSize:'0.78rem', fontWeight:600, color:BRAND }}>{p}</span>
                    ))}
                  </div>
                </motion.div>
              </div>
              <div className={`col-lg-7 ${i%2===1?'order-lg-1':''}`}>
                <motion.div variants={fadeUp}>
                  <div style={{ background:'rgba(5,14,35,0.7)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:20, padding:24 }}>
                    {f.mockup.map((m,j)=>(
                      <div key={j} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 0', borderBottom:j<f.mockup.length-1?'1px solid rgba(255,255,255,0.05)':'none' }}>
                        <div>
                          <div style={{ fontWeight:600, fontSize:'0.9rem', marginBottom:3 }}>{m.label}</div>
                          <div style={{ fontSize:'0.75rem', color:'rgba(241,245,249,0.4)' }}>{m.sub}</div>
                        </div>
                        <div style={{ fontWeight:800, fontSize:'1rem', color:m.color }}>{m.val}</div>
                      </div>
                    ))}
                  </div>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* NÚMEROS */}
      <section style={{ position:'relative', padding:'80px 0' }}>
        <Separator/>
        <div style={{ maxWidth:1200, margin:'0 auto', padding:'0 24px' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} className="row g-4">
            {[['15+','Operadoras e adquirentes'],['100%','Perícia automatizada'],['< 2min','Para receber o laudo'],['73%','Têm cobranças indevidas*']].map(([v,l])=>(
              <div key={l} className="col-6 col-lg-3">
                <motion.div variants={fadeUp}>
                  <div style={{ textAlign:'center', padding:'26px 16px', background:`rgba(${BRAND_RGB},0.04)`, border:`1px solid rgba(${BRAND_RGB},0.12)`, borderRadius:18 }}>
                    <div style={{ fontSize:'clamp(2rem,5vw,2.6rem)', fontWeight:900, color:BRAND, lineHeight:1 }}>{v}</div>
                    <div style={{ fontSize:'0.78rem', color:'rgba(241,245,249,0.48)', marginTop:8 }}>{l}</div>
                  </div>
                </motion.div>
              </div>
            ))}
          </motion.div>
          <p style={{ textAlign:'center', fontSize:'0.72rem', color:'rgba(241,245,249,0.3)', marginTop:16 }}>*Índice apurado nas auditorias realizadas pela Brasil Soluções Empresariais</p>
        </div>
      </section>

      {/* DEPOIMENTOS */}
      <section id="depoimentos" style={{ position:'relative', padding:'100px 0' }}>
        <Separator/>
        <GlowBg/>
        <div style={{ position:'relative', zIndex:2, maxWidth:1200, margin:'0 auto', padding:'0 24px' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} style={{ textAlign:'center', marginBottom:60 }}>
            <motion.div variants={fadeUp}><Badge>Depoimentos</Badge></motion.div>
            <motion.h2 variants={fadeUp} style={{ fontSize:'clamp(1.8rem,4vw,2.8rem)', fontWeight:900 }}>
              Clientes que recuperaram o que era deles
            </motion.h2>
          </motion.div>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger} className="row g-4">
            {[
              { foto:IMG.depo1, nome:'Marcos Ferreira', cargo:'Empresário — Rede de Mercados', texto:'"Na primeira perícia identificamos R$ 3.200 cobrados indevidamente em três meses. Com o laudo em mãos, a própria operadora reconheceu e ressarciu o valor."' },
              { foto:IMG.depo2, nome:'Ana Paula Costa', cargo:'Gestora Financeira', texto:'"A auditoria manual levava dias e eu sabia que deixava passar coisa. Agora em menos de 2 minutos tenho um laudo técnico completo de todas as divergências."' },
              { foto:IMG.depo3, nome:'Ricardo Lopes', cargo:'Consultor Empresarial', texto:'"Recomendo para qualquer empresa que aceite pagamento em maquininha. A perícia da Brasil Soluções identificou cobranças indevidas que passaram despercebidas por mais de um ano."' },
            ].map((d,i)=>(
              <div key={i} className="col-lg-4">
                <motion.div variants={fadeUp} style={{ height:'100%' }}>
                  <div style={{ ...cardStyle, border:'1px solid rgba(255,255,255,0.07)', padding:28, height:'100%' }}>
                    <div style={{ display:'flex', gap:4, marginBottom:16 }}>
                      {[...Array(5)].map((_,j)=><span key={j} style={{ color:BRAND, fontSize:'0.9rem' }}>★</span>)}
                    </div>
                    <p style={{ fontSize:'0.95rem', color:'rgba(241,245,249,0.75)', lineHeight:1.7, marginBottom:24, fontStyle:'italic' }}>{d.texto}</p>
                    <div style={{ display:'flex', alignItems:'center', gap:14 }}>
                      <img src={d.foto} alt={d.nome} style={{ width:46, height:46, borderRadius:'50%', objectFit:'cover', border:`2px solid rgba(${BRAND_RGB},0.3)` }}/>
                      <div>
                        <div style={{ fontWeight:700, fontSize:'0.9rem' }}>{d.nome}</div>
                        <div style={{ fontSize:'0.75rem', color:'rgba(241,245,249,0.4)' }}>{d.cargo}</div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            ))}
          </motion.div>
          {/* Selos */}
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger}
            style={{ display:'flex', flexWrap:'wrap', justifyContent:'center', gap:12, marginTop:48 }}>
            {[
              { icon:'🔒', label:'Plataforma Segura' },
              { icon:'🏛️', label:'FEBRABAN 3318716408169787' },
              { icon:'⚡', label:'IA Especializada' },
              { icon:'📋', label:'Laudo Técnico Pericial' },
            ].map(s=>(
              <motion.div key={s.label} variants={fadeUp} style={{ display:'flex', alignItems:'center', gap:9, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:12, padding:'11px 18px' }}>
                <span style={{ fontSize:'1.1rem' }}>{s.icon}</span>
                <span style={{ fontSize:'0.8rem', color:'rgba(241,245,249,0.65)', fontWeight:600 }}>{s.label}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ position:'relative', padding:'120px 0', overflow:'hidden' }}>
        <img src={IMG.cta} alt="" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }}/>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, rgba(2,6,23,0.94) 0%, rgba(2,6,23,0.82) 50%, rgba(2,6,23,0.94) 100%)' }}/>
        <Separator/>
        <div style={{ position:'relative', zIndex:2, maxWidth:700, margin:'0 auto', padding:'0 24px', textAlign:'center' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger}>
            <motion.div variants={fadeUp}><Badge>Comece agora</Badge></motion.div>
            <motion.h2 variants={fadeUp} style={{ fontSize:'clamp(2rem,5vw,3rem)', fontWeight:900, marginBottom:20 }}>
              Quanto sua empresa perdeu <span style={{ color:BRAND }}>este mês</span>?
            </motion.h2>
            <motion.p variants={fadeUp} style={{ fontSize:'1.05rem', color:'rgba(241,245,249,0.65)', lineHeight:1.7, marginBottom:40 }}>
              Solicite uma perícia agora e descubra. Nossa consultoria audita o extrato da sua maquininha e entrega o laudo técnico com todos os valores cobrados indevidamente.
            </motion.p>
            <motion.div variants={fadeUp} style={{ display:'flex', flexWrap:'wrap', justifyContent:'center', gap:14 }}>
              <a href="#contato" className="btn btn-brand" style={{ fontSize:'1.05rem', padding:'17px 36px' }}>Solicitar perícia</a>
              <a href="https://wa.me/5547996350535" target="_blank" rel="noopener noreferrer" className="btn btn-wa" style={{ fontSize:'1.05rem', padding:'17px 36px' }}><WaIcon size={20} color="#fff"/> Falar com consultor</a>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* CONTATO */}
      <section id="contato" style={{ position:'relative', padding:'100px 0', background:'rgba(255,255,255,0.01)' }}>
        <Separator/>
        <GlowBg/>
        <div style={{ position:'relative', zIndex:2, maxWidth:760, margin:'0 auto', padding:'0 24px' }}>
          <motion.div initial="hidden" whileInView="show" viewport={{ once:true }} variants={stagger}>
            <motion.div variants={fadeUp} style={{ textAlign:'center', marginBottom:48 }}>
              <Badge>Fale conosco</Badge>
              <h2 style={{ fontSize:'clamp(1.8rem,4vw,2.6rem)', fontWeight:900, margin:'0 0 16px' }}>
                Envie sua <span style={{ color:BRAND }}>dúvida ou documento</span>
              </h2>
              <p style={{ color:'rgba(241,245,249,0.55)', fontSize:'1rem', lineHeight:1.7, maxWidth:520, margin:'0 auto' }}>
                Envie sua dúvida, anexe contratos ou extratos e nossa equipe de consultoria entrará em contato pelo WhatsApp ou e-mail.
              </p>
            </motion.div>

            <motion.form variants={fadeUp} onSubmit={handleContatoSubmit}
              style={{ background:'rgba(255,255,255,0.025)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:24, padding:'36px 32px' }}>
              <style>{`
                .ctinput { width:100%; background:rgba(255,255,255,0.05); border:1px solid rgba(255,255,255,0.1); border-radius:12px; padding:13px 16px; color:#f1f5f9; font-size:0.9rem; outline:none; transition:border-color 0.2s; font-family:inherit; }
                .ctinput:focus { border-color:rgba(${BRAND_RGB},0.5); }
                .ctinput::placeholder { color:rgba(241,245,249,0.3); }
                .ctlabel { display:block; font-size:0.78rem; font-weight:700; color:rgba(241,245,249,0.5); margin-bottom:7px; text-transform:uppercase; letter-spacing:0.06em; }
              `}</style>

              <div className="row g-3" style={{ marginBottom:0 }}>
                <div className="col-md-6">
                  <label className="ctlabel">Nome *</label>
                  <input className="ctinput" type="text" placeholder="Seu nome completo"
                    value={contatoNome} onChange={e => setContatoNome(e.target.value)} required maxLength={200}/>
                </div>
                <div className="col-md-6">
                  <label className="ctlabel">E-mail</label>
                  <input className="ctinput" type="email" placeholder="seu@email.com"
                    value={contatoEmail} onChange={e => setContatoEmail(e.target.value)} maxLength={200}/>
                </div>
                <div className="col-md-6">
                  <label className="ctlabel">WhatsApp / Telefone</label>
                  <input className="ctinput" type="text" placeholder="(47) 99999-9999"
                    value={contatoTelefone} onChange={e => setContatoTelefone(e.target.value)} maxLength={30}/>
                </div>
                <div className="col-12">
                  <label className="ctlabel">Mensagem *</label>
                  <textarea className="ctinput" rows={5} placeholder="Descreva sua dúvida ou situação..."
                    value={contatoMensagem} onChange={e => setContatoMensagem(e.target.value)} required maxLength={5000}
                    style={{ resize:'vertical', minHeight:120 }}/>
                  <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.25)', marginTop:4, textAlign:'right' }}>
                    {contatoMensagem.length}/5000
                  </div>
                </div>

                {/* Anexos */}
                <div className="col-12">
                  <label className="ctlabel">Anexos (opcional) — máx. 5 arquivos, 10 MB cada</label>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'center' }}>
                    {contatoArquivos.length < 5 && (
                      <label style={{ display:'inline-flex', alignItems:'center', gap:8, background:`rgba(${BRAND_RGB},0.08)`, border:`1px dashed rgba(${BRAND_RGB},0.35)`, borderRadius:12, padding:'11px 20px', cursor:'pointer', fontSize:'0.85rem', color:BRAND, fontWeight:600, transition:'all 0.2s' }}
                        onMouseEnter={e=>e.currentTarget.style.background=`rgba(${BRAND_RGB},0.14)`}
                        onMouseLeave={e=>e.currentTarget.style.background=`rgba(${BRAND_RGB},0.08)`}>
                        📎 Anexar arquivo
                        <input ref={fileInputContatoRef} type="file" multiple accept="image/*,.pdf,.doc,.docx,.txt,.csv"
                          style={{ display:'none' }} onChange={handleContatoFiles}/>
                      </label>
                    )}
                    {contatoArquivos.map((f, i) => (
                      <div key={i} style={{ display:'flex', alignItems:'center', gap:8, background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'8px 12px', fontSize:'0.8rem', color:'rgba(241,245,249,0.7)', maxWidth:220 }}>
                        <span style={{ fontSize:'1rem' }}>{f.type.startsWith('image/') ? '🖼️' : '📄'}</span>
                        <span style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flex:1 }}>{f.name}</span>
                        <button type="button" onClick={() => removeContatoFile(i)}
                          style={{ background:'transparent', border:'none', color:'rgba(241,245,249,0.4)', cursor:'pointer', fontSize:'0.9rem', padding:0, flexShrink:0, lineHeight:1 }}>✕</button>
                      </div>
                    ))}
                  </div>
                  <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.25)', marginTop:6 }}>
                    Formatos aceitos: imagens (JPG, PNG, GIF, WEBP), PDF, DOC, DOCX, TXT, CSV
                  </div>
                </div>

                {contatoStatus && (
                  <div className="col-12">
                    <div style={{ background: contatoStatus === 'ok' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', border:`1px solid ${contatoStatus === 'ok' ? 'rgba(16,185,129,0.3)' : 'rgba(239,68,68,0.3)'}`, borderRadius:12, padding:'12px 16px', fontSize:'0.88rem', color: contatoStatus === 'ok' ? '#6ee7b7' : '#fca5a5', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <span>{contatoStatus === 'ok' ? '✅' : '⚠'} {contatoStatusMsg}</span>
                      <button type="button" onClick={() => setContatoStatus(null)} style={{ background:'transparent', border:'none', cursor:'pointer', color:'inherit', fontSize:'1rem', padding:0 }}>✕</button>
                    </div>
                  </div>
                )}

                <div className="col-12" style={{ display:'flex', justifyContent:'flex-end', marginTop:8 }}>
                  <button type="submit" disabled={contatoSending || !contatoNome.trim() || !contatoMensagem.trim()}
                    className="btn btn-brand" style={{ padding:'14px 36px', fontSize:'0.95rem', opacity: (contatoSending || !contatoNome.trim() || !contatoMensagem.trim()) ? 0.6 : 1, cursor: (contatoSending || !contatoNome.trim() || !contatoMensagem.trim()) ? 'not-allowed' : 'pointer', display:'flex', alignItems:'center', gap:10 }}>
                    {contatoSending
                      ? <><span style={{ width:16, height:16, border:'2px solid rgba(0,0,0,0.2)', borderTopColor:'#020617', borderRadius:'50%', display:'inline-block', animation:'spin 0.8s linear infinite' }}/> Enviando...</>
                      : <>📤 Enviar mensagem</>
                    }
                  </button>
                </div>
              </div>
            </motion.form>
          </motion.div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ background:'rgba(2,6,23,0.98)', borderTop:`1px solid rgba(${BRAND_RGB},0.1)`, padding:'64px 24px 32px' }}>
        <div style={{ maxWidth:1200, margin:'0 auto' }}>

          {/* Faixa Brasil Soluções */}
          <div style={{ background:`rgba(${BRAND_RGB},0.05)`, border:`1px solid rgba(${BRAND_RGB},0.15)`, borderRadius:18, padding:'24px 32px', marginBottom:48, display:'flex', flexWrap:'wrap', alignItems:'center', justifyContent:'space-between', gap:20 }}>
            <div style={{ display:'flex', alignItems:'center', gap:16 }}>
              <div style={{ width:48, height:48, borderRadius:12, background:`rgba(${BRAND_RGB},0.12)`, border:`1px solid rgba(${BRAND_RGB},0.3)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.4rem', flexShrink:0 }}>🏢</div>
              <div>
                <div style={{ fontWeight:800, color:BRAND, fontSize:'1rem', lineHeight:1.2 }}>Brasil Soluções Empresariais</div>
                <div style={{ fontSize:'0.78rem', color:'rgba(241,245,249,0.5)', marginTop:3 }}>
                  Reescrevendo o futuro da sua empresa. Soluções Empresariais 360º.
                </div>
              </div>
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'center' }}>
              <a href="https://brasilsolucoesempresariais.com" target="_blank" rel="noopener noreferrer"
                style={{ display:'flex', alignItems:'center', gap:7, background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:10, padding:'8px 16px', color:'rgba(241,245,249,0.7)', textDecoration:'none', fontSize:'0.82rem', fontWeight:600, transition:'all 0.2s' }}
                onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.1)'}
                onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.06)'}>
                🌐 brasilsolucoesempresariais.com
              </a>
              <a href="https://wa.me/5547996350535" target="_blank" rel="noopener noreferrer"
                style={{ display:'flex', alignItems:'center', gap:8, background:'rgba(37,211,102,0.1)', border:'1px solid rgba(37,211,102,0.3)', borderRadius:10, padding:'8px 16px', color:'#4ade80', textDecoration:'none', fontSize:'0.82rem', fontWeight:600, transition:'all 0.2s' }}
                onMouseEnter={e=>e.currentTarget.style.background='rgba(37,211,102,0.18)'}
                onMouseLeave={e=>e.currentTarget.style.background='rgba(37,211,102,0.1)'}>
                <WaIcon size={15} color="#4ade80"/> (47) 99635-0535
              </a>
            </div>
          </div>

          <div className="row g-4" style={{ marginBottom:40 }}>
            {/* Coluna produto */}
            <div className="col-lg-4">
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
                <div style={{ width:34, height:34, borderRadius:10, background:`rgba(${BRAND_RGB},0.15)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1rem' }}>📊</div>
                <span style={{ fontWeight:800, color:BRAND, fontSize:'1.1rem' }}>Delator</span>
              </div>
              <p style={{ fontSize:'0.82rem', color:'rgba(241,245,249,0.4)', lineHeight:1.7, maxWidth:280, marginBottom:16 }}>
                Plataforma exclusiva da <strong style={{ color:'rgba(241,245,249,0.65)' }}>Brasil Soluções Empresariais</strong> para consultoria e perícia bancária em taxas de maquininha — identificamos cobranças indevidas e geramos laudo técnico completo.
              </p>
              {/* Selos de credencial */}
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:9, padding:'7px 13px', width:'fit-content' }}>
                  <span style={{ fontSize:'0.85rem' }}>🏛️</span>
                  <div>
                    <div style={{ fontSize:'0.68rem', color:'rgba(241,245,249,0.35)', lineHeight:1 }}>Inscrição FEBRABAN</div>
                    <div style={{ fontSize:'0.72rem', fontWeight:700, color:'rgba(241,245,249,0.7)', letterSpacing:'0.03em' }}>3318716408169787</div>
                  </div>
                </div>
                <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:9, padding:'7px 13px', width:'fit-content' }}>
                  <span style={{ fontSize:'0.85rem' }}>🔒</span>
                  <div>
                    <div style={{ fontSize:'0.68rem', color:'rgba(241,245,249,0.35)', lineHeight:1 }}>Plataforma</div>
                    <div style={{ fontSize:'0.75rem', fontWeight:700, color:'rgba(241,245,249,0.7)' }}>Segura SSL/TLS</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Navegação */}
            <div className="col-6 col-lg-2">
              <div style={{ fontWeight:700, fontSize:'0.82rem', color:'rgba(241,245,249,0.5)', marginBottom:16, textTransform:'uppercase', letterSpacing:'0.08em' }}>Navegação</div>
              {[['#beneficios','Benefícios'],['#como-usar','Como Usar'],['#funcionalidades','Funcionalidades'],['#depoimentos','Depoimentos']].map(([h,l])=>(
                <a key={h} href={h} style={{ display:'block', color:'rgba(241,245,249,0.45)', textDecoration:'none', fontSize:'0.85rem', marginBottom:10, transition:'color 0.2s' }}
                  onMouseEnter={e=>e.target.style.color='#f1f5f9'} onMouseLeave={e=>e.target.style.color='rgba(241,245,249,0.45)'}>{l}</a>
              ))}
            </div>

            {/* Contato */}
            <div className="col-6 col-lg-2">
              <div style={{ fontWeight:700, fontSize:'0.82rem', color:'rgba(241,245,249,0.5)', marginBottom:16, textTransform:'uppercase', letterSpacing:'0.08em' }}>Contato</div>
              <a href="https://wa.me/5547996350535" target="_blank" rel="noopener noreferrer"
                style={{ display:'flex', alignItems:'center', gap:7, color:'#4ade80', textDecoration:'none', fontSize:'0.85rem', marginBottom:10 }}>
                <WaIcon size={14} color="#4ade80"/> (47) 99635-0535
              </a>
              <a href="https://www.instagram.com/brasilsolucoesempresariais" target="_blank" rel="noopener noreferrer"
                style={{ display:'flex', alignItems:'center', gap:7, color:'rgba(241,245,249,0.45)', textDecoration:'none', fontSize:'0.85rem', marginBottom:10, transition:'color 0.2s' }}
                onMouseEnter={e=>e.currentTarget.style.color='#f1f5f9'} onMouseLeave={e=>e.currentTarget.style.color='rgba(241,245,249,0.45)'}>
                <InstagramIcon size={14}/> @brasilsolucoesempresariais
              </a>
              <a href="mailto:contato@brasilsolucoesempresariais" target="_blank" rel="noopener noreferrer"
                style={{ display:'flex', alignItems:'center', gap:7, color:'rgba(241,245,249,0.45)', textDecoration:'none', fontSize:'0.85rem', marginBottom:10, transition:'color 0.2s' }}
                onMouseEnter={e=>e.currentTarget.style.color='#f1f5f9'} onMouseLeave={e=>e.currentTarget.style.color='rgba(241,245,249,0.45)'}>
                ✉ contato@brasilsolucoesempresariais
              </a>
              <a href="https://brasilsolucoesempresariais.com" target="_blank" rel="noopener noreferrer"
                style={{ display:'flex', alignItems:'center', gap:7, color:'rgba(241,245,249,0.45)', textDecoration:'none', fontSize:'0.85rem', transition:'color 0.2s' }}
                onMouseEnter={e=>e.currentTarget.style.color='#f1f5f9'} onMouseLeave={e=>e.currentTarget.style.color='rgba(241,245,249,0.45)'}>
                🌐 Site
              </a>
            </div>

            {/* Acesso rápido */}
            <div className="col-lg-4">
              <div style={{ fontWeight:700, fontSize:'0.82rem', color:'rgba(241,245,249,0.5)', marginBottom:16, textTransform:'uppercase', letterSpacing:'0.08em' }}>Acesso rápido</div>
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                <Link to="/login" className="btn btn-glass" style={{ textAlign:'center', padding:'12px 20px', fontSize:'0.875rem' }}>Entrar no sistema</Link>
                <Link to="/cadastro" className="btn btn-brand" style={{ textAlign:'center', padding:'12px 20px', fontSize:'0.875rem' }}>Criar conta grátis</Link>
                <a href="https://wa.me/5547996350535" target="_blank" rel="noopener noreferrer" className="btn btn-wa" style={{ justifyContent:'center', padding:'12px 20px', fontSize:'0.875rem' }}>
                  <WaIcon size={17} color="#fff"/> Falar pelo WhatsApp
                </a>
              </div>
            </div>
          </div>

          {/* Rodapé inferior */}
          <div style={{ borderTop:'1px solid rgba(255,255,255,0.06)', paddingTop:24, display:'flex', flexWrap:'wrap', justifyContent:'space-between', alignItems:'center', gap:12 }}>
            <div>
              <span style={{ fontSize:'0.78rem', color:'rgba(241,245,249,0.3)' }}>© 2025 </span>
              <span style={{ fontSize:'0.78rem', color:'rgba(241,245,249,0.5)', fontWeight:600 }}>Brasil Soluções Empresariais</span>
              <span style={{ fontSize:'0.78rem', color:'rgba(241,245,249,0.3)' }}> — Consultoria e Perícia Bancária. Todos os direitos reservados.</span>
            </div>
            <div style={{ display:'flex', gap:16, flexWrap:'wrap', alignItems:'center' }}>
              <span style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.25)' }}>FEBRABAN · 3318716408169787</span>
              <span style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.15)' }}>|</span>
              <a href="https://brasilsolucoesempresariais.com" target="_blank" rel="noopener noreferrer" style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.25)', textDecoration:'none' }}>brasilsolucoesempresariais.com</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
